export interface OpenProjectTabDeps {
  isReady: () => Promise<boolean>;
  onNotReady: () => void;
  origin: string;
  openWindow: (url: string, target: string) => Window | null;
}

export const buildProjectDetailPath = (
  projectId: string,
  isAR: boolean,
): string => (isAR ? `/ar/${projectId}` : `/${projectId}`);

export const isClickWithinCard = (
  cardEl: { contains: (node: Node | null) => boolean } | null,
  target: Node | null,
): boolean => !!cardEl && cardEl.contains(target);

export const openReadyProjectTab = (
  projectId: string,
  isAR: boolean,
  deps: {
    origin: string;
    openWindow: (url: string, target: string) => Window | null;
  },
): void => {
  const url = `${deps.origin}${buildProjectDetailPath(projectId, isAR)}`;
  const newTab = deps.openWindow(url, "_blank");
  if (newTab) {
    newTab.opener = null;
  }
};

export const openProjectAfterCheck = async (
  projectId: string,
  isAR: boolean,
  deps: OpenProjectTabDeps,
): Promise<void> => {
  let ready = false;
  try {
    ready = await deps.isReady();
  } catch (err) {
    console.error("openProjectAfterCheck error", err);
    ready = false;
  }
  if (!ready) {
    deps.onNotReady();
    return;
  }
  const url = `${deps.origin}${buildProjectDetailPath(projectId, isAR)}`;
  const newTab = deps.openWindow(url, "_blank");
  if (newTab) {
    newTab.opener = null;
  }
};

export const openProjectInNewTab = async (
  projectId: string,
  isAR: boolean,
  deps: OpenProjectTabDeps,
): Promise<void> => {
  const newTab = deps.openWindow("about:blank", "_blank");
  try {
    const ready = await deps.isReady();
    if (!ready) {
      newTab?.close();
      deps.onNotReady();
      return;
    }
    const url = `${deps.origin}${buildProjectDetailPath(projectId, isAR)}`;
    if (newTab) {
      newTab.opener = null;
      newTab.location.href = url;
    }
  } catch (err) {
    newTab?.close();
    console.error("openProjectInNewTab error", err);
  }
};
